import { render } from "./TopicsTable.vue?vue&type=template&id=3ff81ecf"
import script from "./TopicsTable.vue?vue&type=script&lang=js"
export * from "./TopicsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__